import { FC, useMemo } from "react";
import { useTaxonomyContext } from "../../../contexts/Taxonomy/TaxonomyContext";
import TreeSelect from "../TreeSelect/TreeSelect";
import { transformToTree } from "../TreeSelect/utils";
import {
  SelectionRules,
  SELECTION_PRESETS,
} from "../TreeSelect/hooks/useHierarchicalSelection";

interface SpendCategoryInputProps {
  onSpendCategorySelect: (spendCategoryIds: string[]) => void;
  selectedItems: string[];
  id?: string;
  onClose?: () => void;
  selectionRules?: SelectionRules;
  showDoneButton?: boolean;
}

export const SpendCategoryInput: FC<SpendCategoryInputProps> = ({
  onSpendCategorySelect,
  selectedItems = [],
  id = "spend-category-input",
  onClose,
  selectionRules = SELECTION_PRESETS.hierarchical,
  showDoneButton,
}) => {
  const { spendCategories, spendCategoriesLoading } = useTaxonomyContext();

  const options = useMemo(() => {
    const tree = transformToTree(spendCategories, (category) => category.name);
    return tree[0]?.children || [];
  }, [spendCategories]);

  return (
    <TreeSelect
      id={id}
      items={options}
      selectedItems={selectedItems}
      onSelectItems={onSpendCategorySelect}
      placeholder="Search Spend Categories"
      noOptionsMessage="No Results"
      onClose={onClose}
      selectionRules={selectionRules}
      loading={spendCategoriesLoading}
      allExpanded
      showDoneButton={showDoneButton}
    />
  );
};
